// extracted by mini-css-extract-plugin
export default {"container":"Layout-module--container--AI465","header":"Layout-module--header--fYiCf","footer":"Layout-module--footer--zec99","main":"Layout-module--main--IApBM"};